export const data=[
   { course: 'Digital Marketing',
    date: '28/07/21',
    time: '6pm',
    duration: '2 hours',
    trainer: 'John',}
]